import buildBooleanFilter from '../buildBooleanFilter'

const StarterLotsFilter = buildBooleanFilter({
  key: 'starterLots',
  filterTitle: 'starter_lots',
})

export default StarterLotsFilter
